<app-header></app-header>
<main>

    <!-- ───────────────────── HERO ───────────────────── -->
    <section class="hero">
        <img class="hero-bg-shield" src="assets/shield-ico.svg" aria-hidden="true" />

        <div class="hero-content">
            <img
                class="standard-logo-img"
                src="assets/tarcza.svg"
                alt="Standard Bezpiecznych Przeglądów Technicznych"
            />

            <p class="hero-subtitle">
                Certyfikat potwierdzający prowadzenie przeglądów gazowych
                i kominiarskich w zunifikowanym środowisku cyfrowym.
            </p>
            <a [routerLink]="['/certyfikat-przeglady']" fragment="o-standardzie" class="btn btn-white btn-l">
                Dowiedz się więcej
            </a>
        </div>
    </section>

    <!-- ───────────────────── O STANDARDZIE ───────────────────── -->
    <section class="about" id="o-standardzie">
        <div class="container">
            <h2>Czym jest Standard Bezpiecznych Przeglądów Technicznych?</h2>
            <p>
                Standard Bezpiecznych Przeglądów Technicznych to certyfikacja
                przyznawana zarządcom nieruchomości, którzy prowadzą przeglądy
                gazowe i kominiarskie w oparciu o cyfrowe środowisko
                dokumentacyjne platformy iMieszkaniec.pl.
            </p>
            <p>
                Certyfikat stanowi potwierdzenie, że organizacja spełnia
                wymagania dotyczące kompletności, bezpieczeństwa i
                weryfikowalności dokumentacji technicznej budynków.
            </p>
        </div>
    </section>

    <!-- ───────────────────── DLA MIESZKAŃCA ───────────────────── -->
    <section class="resident">
        <div class="container">
            <h2>Co to oznacza dla mieszkańca?</h2>
            <p class="resident-intro">
                Jesteś mieszkańcem budynku zarządzanego przez certyfikowaną organizację?
                Oto co certyfikat oznacza w praktyce:
            </p>
            <div class="resident-items">
                <div class="resident-item">
                    <div class="resident-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 9.5L12 4L21 9.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5Z" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9 21V12h6v9" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div class="resident-text">
                        <strong>Twoje instalacje są regularnie kontrolowane</strong>
                        <p>Przeglądy gazowe i kominiarskie są przeprowadzane terminowo i dokumentowane w systemie cyfrowym — nie na papierze.</p>
                    </div>
                </div>
                <div class="resident-item">
                    <div class="resident-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9 12l2 2 4-4" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div class="resident-text">
                        <strong>Masz pewność, że przegląd się odbył</strong>
                        <p>Każdy wykonany przegląd jest zarejestrowany cyfrowo z datą i zakresem — możliwy do weryfikacji w każdej chwili.</p>
                    </div>
                </div>
                <div class="resident-item">
                    <div class="resident-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6Z" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M14 2v6h6M9 13h6M9 17h4" stroke="white" stroke-width="1.8" stroke-linecap="round"/>
                        </svg>
                    </div>
                    <div class="resident-text">
                        <strong>Usterki nie giną w papierach</strong>
                        <p>Wszelkie nieprawidłowości wykryte podczas przeglądu są rejestrowane i trafiają do odpowiednich osób do usunięcia.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- ───────────────────── GWARANCJE ───────────────────── -->
    <section class="guarantees">
        <div class="container">
            <h2>Co gwarantuje certyfikat?</h2>
            <p class="section-intro">
                Organizacja posiadająca certyfikat prowadzi przeglądy
                w oparciu o jednolite środowisko dokumentacyjne zapewniające:
            </p>
            <div class="guarantees-grid">

                <div class="guarantee-card">
                    <div class="guarantee-card-top">
                        <div class="guarantee-icon">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <ellipse cx="12" cy="6" rx="8" ry="3" stroke="white" stroke-width="1.8"/>
                                <path d="M4 6v4c0 1.66 3.58 3 8 3s8-1.34 8-3V6" stroke="white" stroke-width="1.8" stroke-linecap="round"/>
                                <path d="M4 10v4c0 1.66 3.58 3 8 3s8-1.34 8-3v-4" stroke="white" stroke-width="1.8" stroke-linecap="round"/>
                            </svg>
                        </div>
                        <span class="guarantee-num">01</span>
                    </div>
                    <h3>Kompletność danych</h3>
                    <p>Wszystkie informacje o przeglądach gromadzone w jednym cyfrowym środowisku.</p>
                </div>

                <div class="guarantee-card">
                    <div class="guarantee-card-top">
                        <div class="guarantee-icon">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="5" y="11" width="14" height="10" rx="2" stroke="white" stroke-width="1.8"/>
                                <path d="M8 11V7a4 4 0 0 1 8 0v4" stroke="white" stroke-width="1.8" stroke-linecap="round"/>
                                <circle cx="12" cy="16" r="1.5" fill="white"/>
                            </svg>
                        </div>
                        <span class="guarantee-num">02</span>
                    </div>
                    <h3>Bezpieczeństwo i archiwizacja</h3>
                    <p>Dokumentacja chroniona i archiwizowana zgodnie z wymogami prawnymi.</p>
                </div>

                <div class="guarantee-card">
                    <div class="guarantee-card-top">
                        <div class="guarantee-icon">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="11" cy="11" r="7" stroke="white" stroke-width="1.8"/>
                                <path d="M16.5 16.5L21 21" stroke="white" stroke-width="1.8" stroke-linecap="round"/>
                                <path d="M8 11h6M11 8v6" stroke="white" stroke-width="1.8" stroke-linecap="round"/>
                            </svg>
                        </div>
                        <span class="guarantee-num">03</span>
                    </div>
                    <h3>Weryfikacja wykonania przeglądów</h3>
                    <p>Możliwość potwierdzenia terminu i zakresu każdego przeprowadzonego przeglądu.</p>
                </div>

                <div class="guarantee-card">
                    <div class="guarantee-card-top">
                        <div class="guarantee-icon">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" stroke="white" stroke-width="1.8" stroke-linecap="round"/>
                                <rect x="9" y="3" width="6" height="4" rx="1" stroke="white" stroke-width="1.8"/>
                                <path d="M9 12h6M9 16h4" stroke="white" stroke-width="1.8" stroke-linecap="round"/>
                            </svg>
                        </div>
                        <span class="guarantee-num">04</span>
                    </div>
                    <h3>Rejestracja usterek i zaleceń</h3>
                    <p>Precyzyjna ewidencja nieprawidłowości i zaleceń pokontrolnych.</p>
                </div>

            </div>
        </div>
    </section>


</main>
<app-footer></app-footer>
